module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073f5_logo_200x200.3f69b2d5.png";